export const SIGNUP_URL = 'https://engagement.kolanut.ai/signup';

export const engagementHero = {
  imageSrc: '/hero_engagement.png',
  imageAlt: 'Hands typing on a smartphone',
  imagePosition: 'object-[center_40%] sm:object-center',
};

/** Replace imageSrc with final assets in /public/engagement/ — see imageHint per row */
export const whatKolanutDoesFeatures = [
  {
    tag: 'Outreach',
    headline: 'Follow up with every customer.',
    body: 'They send personalized emails, SMS, and chat in your voice. No copy-paste. No customer left waiting.',
    imageSrc:
      'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=900&h=700&fit=crop&q=80',
    imageAlt: 'Placeholder: calm workspace, soft morning light',
    imageHint:
      'Use a soft, desaturated lifestyle shot: founder at a café or home desk, relaxed, glancing at phone. Warm natural light, muted greens and creams. Leave space on the right for chat overlays.',
    overlayType: 'chat',
    overlayChat: [
      { role: 'customer', text: 'Hey, do you have my size back in stock?' },
      { role: 'kolanut', text: 'On it! I sent a restock note and a 10% welcome-back offer.' },
    ],
  },
  {
    tag: 'Churn saves',
    headline: 'Catch buyers before they leave.',
    body: 'They flag at-risk customers, draft the save message, and queue it for you. You approve. They send.',
    imageSrc:
      'https://images.unsplash.com/photo-1518531933037-91b2f5f229cc?w=900&h=700&fit=crop&q=80',
    imageAlt: 'Placeholder: soft-focus green foliage',
    imageHint:
      'Use out-of-focus nature: soft green leaves or gentle bokeh. Calm, airy, minimal. Works well behind a frosted inbox-style panel.',
    overlayType: 'inbox',
    overlayInbox: {
      title: 'Flagging at-risk customers…',
      rows: [
        { initial: 'M', color: 'bg-sky-500', name: 'Maya R.', subject: 'Has not ordered in 45 days', snippet: 'Save offer drafted' },
        { initial: 'J', color: 'bg-amber-500', name: 'James L.', subject: 'Cart abandoned twice', snippet: 'Win-back SMS ready' },
        { initial: 'A', color: 'bg-rose-500', name: 'Ava S.', subject: 'Subscription pause requested', snippet: 'Retention flow queued' },
      ],
    },
  },
  {
    tag: 'Loyalty',
    headline: 'Keep repeat buyers coming back.',
    body: 'They launch win-backs, referrals, and loyalty journeys in minutes, then keep them running while you focus on the business.',
    imageSrc:
      'https://images.unsplash.com/photo-1497215728101-856f4ea42174?w=900&h=700&fit=crop&q=80',
    imageAlt: 'Placeholder: minimal bright office with plants',
    imageHint:
      'Use a clean, bright scene with plants or soft textures: organized desk, neutral tones, lots of negative space. Feels calm and in control, not busy.',
    overlayType: 'chat',
    overlayChat: [
      { role: 'kolanut', text: 'Loyalty campaign live: 3-win streak reward for repeat buyers.' },
      { role: 'customer', text: 'Nice. 127 customers enrolled in the first hour.' },
    ],
  },
  {
    tag: 'Handoff',
    headline: 'You stay in charge. They do the work.',
    body: 'Kolanut handles the daily engagement grind and surfaces what needs your sign-off. Your customers feel looked after. You get your week back.',
    imageSrc:
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=900&h=700&fit=crop&q=80',
    imageAlt: 'Placeholder: person walking outdoors, soft light',
    imageHint:
      'Use a person walking outside or in a quiet space, shot from behind or side profile. Golden hour or soft overcast. Conveys freedom while work runs in the background.',
    overlayType: 'summary',
    overlaySummary: {
      title: 'Today from your engagement manager',
      lines: ['14 follow-ups sent', '3 churn saves queued for approval', '2 loyalty rewards delivered'],
    },
  },
];

export const benefits = [
  {
    metric: '+20-30%',
    label: 'retention',
    detail: 'Your hire keeps more customers coming back. You stop re-buying the same audience.',
  },
  {
    metric: 'Higher LTV',
    label: 'per customer',
    detail: 'They turn one-time buyers into repeat buyers. That is where margin actually lives.',
  },
  {
    metric: 'Your time',
    label: 'back in your week',
    detail: 'Kolanut handles engagement ops. You run product, ops, and the rest of the business.',
  },
];

export const testimonials = [
  {
    quote:
      'We hired Kolanut like a team member. They follow up with customers, catch churn early, and we finally got out of the inbox.',
    name: 'Jordan M.',
    role: 'Founder, DTC skincare brand',
  },
  {
    quote:
      'It feels like adding a retention hire on day one. They own outreach and loyalty. We did not add another salary.',
    name: 'Priya K.',
    role: 'Co-founder, online wellness shop',
  },
  {
    quote:
      'Our repeat revenue climbed in the first month. They watch who is slipping and reach out before we lose the sale.',
    name: 'Marcus T.',
    role: 'CEO, specialty e-commerce store',
  },
];
